import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { LearningCenterService } from '../../learning-center.service';
import { SystemGlobalsService } from '../../system-globals.service';
import { Preloads } from '../component-interfaces';
import { SimpleItem, SimpleItemData, SimpleItemTypes } from './manage-item-types';

@Component({
  selector: 'manage-item-list',
  templateUrl: './manage-item-list.component.html',
  styleUrls: ['./manage-item-list.component.scss']
})
export class ManageItemListComponent implements OnInit, Preloads {
  @ViewChild('deleteItemModal') public deleteItemModal: ModalDirective;

  items: SimpleItem[] = [];

  @Input() itemType: SimpleItemTypes = SimpleItemTypes.Qualification;
  @Input() itemTypeName: string;

  newItemName: string = '';

  isBusySaving: boolean = false;
  isLoaded: boolean = false;
  isEditingItem: boolean = false;

  public selectedItem: SimpleItem;

  constructor(private lcService: LearningCenterService, private toast: ToastService, public globals: SystemGlobalsService) { }  

  hasLoaded(): boolean {
    return this.isLoaded;
  }

  ngOnInit() {
    this.loadItems();
  }

  loadItems() {
    this.isLoaded = false;

    this.lcService.getSimpleItems(this.itemType).subscribe(items => {
      this.items = items.map(item => plainToClass(SimpleItem, item));
      this.isLoaded = true;
    });
  }

  createNewItem() {
    let newItem: SimpleItem = plainToClass(SimpleItem, {
      name: this.newItemName,
      id: null,
      created: null,
      modified: null,
    });

    this.isBusySaving = true;

    this.lcService.saveSimpleItem(this.itemType, newItem).subscribe(
      item => {
        this.items.push(plainToClass(SimpleItem, item));

        this.toast.success('Created new ' + this.itemTypeName, 'Success', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
        this.newItemName = '';
        this.isBusySaving = false;
      },
      error => {
        this.toast.error(error.error.name, 'Error', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
        this.isBusySaving = false;
      }
    );
  }

  confirmDeleteItem(item: SimpleItem) {
    this.selectedItem = item;
    this.deleteItemModal.show();
  }

  editItem(item: SimpleItem) {
    item.toggleEdit();
  }

  updateItem(item: SimpleItem) {
    this.lcService.saveSimpleItem(this.itemType, item).subscribe(
      () => {
        this.toast.success(this.itemTypeName + ' name updated', 'Success', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
        item.toggleEdit();
      },
      error => {
        this.toast.error(error.error.name, 'Error', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
      }
    );
  }

  cancelUpdateItem(item: SimpleItem) {
    item.cancelEdit();
  }

  deleteItem(item: SimpleItem) {
    this.isBusySaving = true;
    
    this.lcService.deleteSimpleItem(this.itemType, item.id).subscribe(
      () => {
        this.items.splice(this.items.indexOf(item), 1);

        this.onAfterDeleteItem();
        this.toast.success('Deleted ' + this.globals.constants._g_qualificationItemName, 'Success', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
      },
      error => {
        this.onAfterDeleteItem();
        this.toast.error(error.error.name, 'Error', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
      }
    );    
  }

  onAfterDeleteItem() {
    this.isBusySaving = false;
    this.deleteItemModal.hide();
  }

}
